module.exports = __webpack_public_path__ + "img/logomini.4b26895e.png";